import { fieldTypes, SectionHeader } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import "./ComplexFields.scss";
import { DepositApplicationReadDTO } from "@/types";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";

export interface ChecksOptInComplexValue {
  showHeader?: boolean;
  headerLabel?: string;
  readOnly?: boolean;
}

export interface ChecksOptInComplexFieldProps extends fieldTypes.BaseFieldProps<any> {
  formValue?: DepositApplicationReadDTO;
}

export const ChecksOptInComplexField: FC<ChecksOptInComplexFieldProps> = (props) => {
  const checksOptInComplexValue = props.complexFieldValue as ChecksOptInComplexValue;
  const readOnly = checksOptInComplexValue?.readOnly || props.readOnly;

  return (
    <section className="complex-field-container checks-opt-in">
      <SectionHeader label={checksOptInComplexValue?.headerLabel || props.label} hidden={!checksOptInComplexValue?.showHeader} />
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.CHECKS_OPT_IN.IS_CHECKS_OPT_IN_ENABLED}
          complexFieldProps={{
            disabled: readOnly,
          }}
        />
        {/* Checks message - show when enabled */}
        {/* {props.formValue?.checksOptIn?.isChecksOptInEnabled && (
          <div className="opt-ins-form-v2__message">
            <div className="opt-ins-form-v2__message-content">
              Concierge Banking will reach out to complete your order following enrollment.
            </div>
          </div>
        )} */}
      </div>
    </section>
  );
};
